import { render, staticRenderFns } from "./riverWaterQuality.vue?vue&type=template&id=98a0525a&scoped=true"
import script from "./riverWaterQuality.vue?vue&type=script&lang=js"
export * from "./riverWaterQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a0525a",
  null
  
)

export default component.exports